import { useMutation, useQueryClient } from "@tanstack/react-query";

import { toast } from "react-toastify";

import { sendCustomNotification } from "../../services/custom_notifications";
import { INotificationQualifiedUsers } from "../../types/custom_notifications";

interface IPayload {
    data: {
        id: number;
        qualifiedUsers: INotificationQualifiedUsers[];
    };
    setIsProcessing: React.Dispatch<React.SetStateAction<boolean>>;
    setApiError: React.Dispatch<React.SetStateAction<string | null>>;
};

interface IResponse {
    statusCode: number;
    message: string;
    error?: string;
}

const useSendCustomNotification = () => {
    const mutationFn = async (payload: IPayload) => {
        return await sendCustomNotification(payload.data.id, payload.data.qualifiedUsers);
    };

    const queryClient = useQueryClient();

    return useMutation({
        mutationFn,
        onMutate: (variables: IPayload) => {
            variables.setIsProcessing(true);
            variables.setApiError(null);
        },
        onSuccess: (response: IResponse, variables: IPayload) => {
            if (response.statusCode === 200) {
                toast.success("Custom Notification sent successfully!");
                queryClient.invalidateQueries({ queryKey: ["custom_notifications"] });
            }
            variables.setIsProcessing(false);
            variables.setApiError(null);
        },
        onError: (error: any, variables: IPayload) => {
            variables.setIsProcessing(false);
            variables.setApiError(error.response?.data?.message); // actual type of error: AxiosError
            toast.error(error.response?.data?.message);
        },
        onSettled: (response: IResponse | undefined, error: any, variables: IPayload) => {
            variables.setIsProcessing(false);
            variables.setApiError(null);
        }
    });
};
export default useSendCustomNotification;